import {createStore,combineReducers, applyMiddleware} from 'redux';
import { GET_INFORMACION_GUIA, GET_MENSAJES, READ_NOTIFICACION, PERMISOS_NOTIFICACION } from './Actions';
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from 'redux-thunk';
import { IMensajeReducer,IGuiaReducer,IMensaje,INotificacionReducer,INotificacionPermisosReducer } from "../interface";

const initialGuia = {};
const initialMensajes:IMensaje[] = []
const notificaciones = {
    "guia":"",
    "numeroNotificaciones":0
}

const guiasReducer = (state = initialGuia, {type,guia}:IGuiaReducer ) => {
    if (type===GET_INFORMACION_GUIA) {
        console.log(guia);
        return {
            ...guia
        }
    }
    return state;
}
const mensajesReducer = (state = initialMensajes, {type,mensajes}:IMensajeReducer ) => {
    if (type===GET_MENSAJES) {
        return mensajes
    }
    return state;
}
const notifiacionReducer = (state = notificaciones, {type,guia,numeroNotifiaciones}:INotificacionReducer ) => {
    if (type===READ_NOTIFICACION) {
        state.numeroNotificaciones=numeroNotifiaciones;
        state.guia=guia;
        console.log(state);
        return state;
    }
    return state;
}

const notificacionPermisosReducer = (state = false,{type,permitido}:INotificacionPermisosReducer) => {
    if (type===PERMISOS_NOTIFICACION) {
        return permitido;
    }
    return state;
}

export default createStore(combineReducers({guiasReducer,mensajesReducer,notifiacionReducer,notificacionPermisosReducer}),composeWithDevTools(applyMiddleware(thunk)));
